import React, { useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Form,
  Grid,
  Input,
  InputMask,
  Row,
  SimpleCollapse,
  SuccessModal
} from 'components'
import useToggle from 'hooks/useToggle'
import { useForm } from 'react-hook-form'
import { FORMAT, SPACING } from 'utils'
import * as Yup from 'yup'

import { EndPoint } from '../../Consolidation'
import ModalEditConsolidation from '../ModalEditConsolidation/ModalEditConsolidation'
import { BusinessUnitTable } from './component/BusinessUnitTable/BusinessUnitTable'

interface IBusinessUnitCollapse {
  listBusiness: any[]
  add: (data: any, type: EndPoint) => Promise<any>
  edit: (data: any, type: EndPoint) => void
  del: (id: number, type: EndPoint) => void
}

export interface ISelectedData {
  idUnidadeNegocioConsolidacao: number
  dsUnidadeNegocioConsolidacao: string
}

const schema = Yup.object({
  dsUnidadeNegocioConsolidacao: Yup.string().required(
    'Unidade Negócio é um campo obrigatório'
  )
})

const BusinessUnitCollapse: React.FC<IBusinessUnitCollapse> = ({
  listBusiness,
  add,
  del,
  edit
}) => {
  const typeEndpoint = 'B'
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [isEditing, toggleIsEditing] = useToggle()
  const [isDeleting, toggleIsDeleting] = useToggle()
  const [selectedData, setselectedData] = useState<ISelectedData | undefined>()

  const handleEdit = (data: any) => {
    edit(
      {
        dsUnidadeNegocioConsolidacao: data.dsUnidadeNegocioConsolidacao,
        idUnidadeNegocioConsolidacao: selectedData.idUnidadeNegocioConsolidacao
      },
      typeEndpoint
    )
    toggleIsEditing()
  }

  const handleSelectData = (objReq: any, type: 'D' | 'E') => {
    setselectedData(objReq)
    if (type === 'E') {
      isEditing === false && toggleIsEditing()
      return
    }

    if (type === 'D') {
      isEditing === false && toggleIsDeleting()
      return
    }
  }

  const handleAdd = (data) => {
    add(data, typeEndpoint).then(() => {
      reset({ dsUnidadeNegocioConsolidacao: '' })
    })
  }

  return (
    <>
      <SimpleCollapse title="Unidade Negócio">
        <Grid
          gridCols="2.5fr 0.4fr 5.5fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
        >
          <Form onSubmit={handleSubmit(handleAdd)}>
            <Row>
              <InputMask
                control={control}
                errors={errors}
                formValue="dsUnidadeNegocioConsolidacao"
                label="Unidade Negócio"
                placeholder="Digite aqui..."
                maxLength={50}
                type="alfanumeric"
              />
              <Button text="+" type="submit" marginLeft={SPACING.spacing20} />
            </Row>
          </Form>
        </Grid>
        <BusinessUnitTable
          tableData={listBusiness}
          selectedData={handleSelectData}
        />
      </SimpleCollapse>
      {!!isEditing && (
        <ModalEditConsolidation
          isOpen={isEditing}
          onClose={toggleIsEditing}
          handleEdit={handleEdit}
          formValue="dsUnidadeNegocioConsolidacao"
          initState={selectedData['dsUnidadeNegocioConsolidacao']}
          title="Editar Empresa"
          validationSchema={schema}
        />
      )}
      {!!isDeleting && (
        <SuccessModal
          open={isDeleting}
          message="Tem certeza deseja deletar?"
          type="alert"
          txtButtonCancel="Voltar"
          txtButtonConfirm="SIM"
          handleCancel={toggleIsDeleting}
          handleConfirm={() => {
            del(selectedData.idUnidadeNegocioConsolidacao, typeEndpoint)
            toggleIsDeleting()
          }}
        />
      )}
    </>
  )
}

export default BusinessUnitCollapse
